const TableName = Symbol.for("drizzle:Name");
export {
  TableName
};
//# sourceMappingURL=table.utils.js.map